module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/main-94fc1e04ce7f8b6646a82c8d7f4adbdf.jpg";